declare namespace $ {

	type $mol_plot_line__series_y_shm_showcase_preview_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_plot_line['series_y'] >
	>
	type $mol_calendar__month_string_shm_showcase_preview_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_calendar['month_string'] >
	>
	type $mol_avatar__id_shm_showcase_preview_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_avatar['id'] >
	>
	type $mol_speck__value_shm_showcase_preview_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_speck['value'] >
	>
	type $mol_check_box__title_shm_showcase_preview_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_showcase_preview_6 = $mol_type_enforce<
		ReturnType< $shm_showcase_preview['pop_opened'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $shm_period__date_from_shm_showcase_preview_7 = $mol_type_enforce<
		ReturnType< $shm_showcase_preview['period_from'] >
		,
		ReturnType< $shm_period['date_from'] >
	>
	type $shm_period__date_to_shm_showcase_preview_8 = $mol_type_enforce<
		ReturnType< $shm_showcase_preview['period_to'] >
		,
		ReturnType< $shm_period['date_to'] >
	>
	type $mol_string__hint_shm_showcase_preview_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_form_field__name_shm_showcase_preview_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__control_shm_showcase_preview_11 = $mol_type_enforce<
		ReturnType< $shm_showcase_preview['Form_input'] >
		,
		ReturnType< $mol_form_field['control'] >
	>
	type $mol_view__title_shm_showcase_preview_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['title'] >
	>
	type $mol_view__sub_shm_showcase_preview_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__title_shm_showcase_preview_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['title'] >
	>
	type $mol_view__sub_shm_showcase_preview_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_showcase_preview_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_button_minor__title_shm_showcase_preview_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__title_shm_showcase_preview_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__title_shm_showcase_preview_19 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_view__sub_shm_showcase_preview_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_showcase_preview_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_showcase_preview_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_paginator__total_shm_showcase_preview_23 = $mol_type_enforce<
		number
		,
		ReturnType< $shm_paginator['total'] >
	>
	type $mol_chart__gap_hor_shm_showcase_preview_24 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_chart['gap_hor'] >
	>
	type $mol_chart__gap_vert_shm_showcase_preview_25 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_chart['gap_vert'] >
	>
	type $mol_chart__graphs_shm_showcase_preview_26 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_chart['graphs'] >
	>
	type $mol_pick__trigger_content_shm_showcase_preview_27 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_showcase_preview_28 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_stack__sub_shm_showcase_preview_29 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_stack['sub'] >
	>
	type $mol_pop__showed_shm_showcase_preview_30 = $mol_type_enforce<
		ReturnType< $shm_showcase_preview['pop_opened'] >
		,
		ReturnType< $mol_pop['showed'] >
	>
	type $mol_pop__Anchor_shm_showcase_preview_31 = $mol_type_enforce<
		ReturnType< $shm_showcase_preview['Pop_toggle'] >
		,
		ReturnType< $mol_pop['Anchor'] >
	>
	type $mol_pop__bubble_content_shm_showcase_preview_32 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pop['bubble_content'] >
	>
	type $mol_card__plugins_shm_showcase_preview_33 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_card['plugins'] >
	>
	type $mol_card__title_shm_showcase_preview_34 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_card['title'] >
	>
	type $mol_button_share__title_shm_showcase_preview_35 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_share['title'] >
	>
	type $mol_button_share__uri_shm_showcase_preview_36 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_share['uri'] >
	>
	type $shm_file_drop__drop_title_shm_showcase_preview_37 = $mol_type_enforce<
		ReturnType< $shm_showcase_preview['file_title'] >
		,
		ReturnType< $shm_file_drop['drop_title'] >
	>
	type $shm_file_drop__files_shm_showcase_preview_38 = $mol_type_enforce<
		ReturnType< $shm_showcase_preview['files'] >
		,
		ReturnType< $shm_file_drop['files'] >
	>
	type $mol_pick__trigger_content_shm_showcase_preview_39 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_showcase_preview_40 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_pick__trigger_content_shm_showcase_preview_41 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_showcase_preview_42 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_form__submit_title_shm_showcase_preview_43 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form['submit_title'] >
	>
	type $mol_form__message_done_shm_showcase_preview_44 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form['message_done'] >
	>
	type $mol_form__body_shm_showcase_preview_45 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form['body'] >
	>
	type $mol_grid__records_shm_showcase_preview_46 = $mol_type_enforce<
		({ 
			'a': ({ 
				'Товар': string,
				'Шт': number,
			}) ,
		}) 
		,
		ReturnType< $mol_grid['records'] >
	>
	type $mol_search__hint_shm_showcase_preview_47 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_search['hint'] >
	>
	type $mol_textarea__value_shm_showcase_preview_48 = $mol_type_enforce<
		ReturnType< $shm_showcase_preview['textarea_value'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_check_list__dictionary_shm_showcase_preview_49 = $mol_type_enforce<
		ReturnType< $shm_showcase_preview['checks_value'] >
		,
		ReturnType< $mol_check_list['dictionary'] >
	>
	type $mol_check_list__options_shm_showcase_preview_50 = $mol_type_enforce<
		({ 
			'a': string,
			'b': string,
		}) 
		,
		ReturnType< $mol_check_list['options'] >
	>
	type $shm_check_list__options_shm_showcase_preview_51 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_check_list['options'] >
	>
	type $mol_select_list__value_shm_showcase_preview_52 = $mol_type_enforce<
		ReturnType< $shm_showcase_preview['multiple_value'] >
		,
		ReturnType< $mol_select_list['value'] >
	>
	type $mol_select_list__dictionary_shm_showcase_preview_53 = $mol_type_enforce<
		({ 
			'a': string,
			'b': string,
		}) 
		,
		ReturnType< $mol_select_list['dictionary'] >
	>
	type $mol_section__title_shm_showcase_preview_54 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_section['title'] >
	>
	type $mol_section__content_shm_showcase_preview_55 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_section['content'] >
	>
	type $mol_toolbar__items_shm_showcase_preview_56 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_toolbar['items'] >
	>
	type $mol_deck__current_shm_showcase_preview_57 = $mol_type_enforce<
		ReturnType< $shm_showcase_preview['deck_current'] >
		,
		ReturnType< $mol_deck['current'] >
	>
	type $mol_deck__items_shm_showcase_preview_58 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_deck['items'] >
	>
	type $mol_gallery__items_shm_showcase_preview_59 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_gallery['items'] >
	>
	type $mol_scroll__sub_shm_showcase_preview_60 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_scroll['sub'] >
	>
	type $mol_frame__html_shm_showcase_preview_61 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_frame['html'] >
	>
	type $shm_echarts__animation_duration_initial_shm_showcase_preview_62 = $mol_type_enforce<
		number
		,
		ReturnType< $shm_echarts['animation_duration_initial'] >
	>
	type $shm_echarts__animation_duration_update_shm_showcase_preview_63 = $mol_type_enforce<
		number
		,
		ReturnType< $shm_echarts['animation_duration_update'] >
	>
	type $shm_echarts__option_shm_showcase_preview_64 = $mol_type_enforce<
		ReturnType< $shm_showcase_preview['chart_option'] >
		,
		ReturnType< $shm_echarts['option'] >
	>
	type $mol_text__text_shm_showcase_preview_65 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_speck__value_shm_showcase_preview_66 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_speck['value'] >
	>
	type $mol_avatar__id_shm_showcase_preview_67 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_avatar['id'] >
	>
	type $mol_portion__portion_shm_showcase_preview_68 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_portion['portion'] >
	>
	type $mol_check_box__checked_shm_showcase_preview_69 = $mol_type_enforce<
		ReturnType< $shm_showcase_preview['checked'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_string__hint_shm_showcase_preview_70 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_button_minor__title_shm_showcase_preview_71 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_text_code__text_shm_showcase_preview_72 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text_code['text'] >
	>
	type $mol_number__value_shm_showcase_preview_73 = $mol_type_enforce<
		ReturnType< $shm_showcase_preview['number_value'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_switch__value_shm_showcase_preview_74 = $mol_type_enforce<
		ReturnType< $shm_showcase_preview['switch_value'] >
		,
		ReturnType< $mol_switch['value'] >
	>
	type $mol_switch__options_shm_showcase_preview_75 = $mol_type_enforce<
		({ 
			'a': string,
			'b': string,
		}) 
		,
		ReturnType< $mol_switch['options'] >
	>
	type $mol_select__value_shm_showcase_preview_76 = $mol_type_enforce<
		ReturnType< $shm_showcase_preview['select_value'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_showcase_preview_77 = $mol_type_enforce<
		({ 
			'a': string,
			'b': string,
		}) 
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_date__value_shm_showcase_preview_78 = $mol_type_enforce<
		ReturnType< $shm_showcase_preview['date_value'] >
		,
		ReturnType< $mol_date['value'] >
	>
	type $mol_pick_time__value_shm_showcase_preview_79 = $mol_type_enforce<
		ReturnType< $shm_showcase_preview['time_value'] >
		,
		ReturnType< $mol_pick_time['value'] >
	>
	type $mol_format__mask_shm_showcase_preview_80 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_format['mask'] >
	>
	type $mol_format__value_shm_showcase_preview_81 = $mol_type_enforce<
		ReturnType< $shm_showcase_preview['format_value'] >
		,
		ReturnType< $mol_format['value'] >
	>
	type $mol_paginator__value_shm_showcase_preview_82 = $mol_type_enforce<
		ReturnType< $shm_showcase_preview['page_value'] >
		,
		ReturnType< $mol_paginator['value'] >
	>
	type $mol_link__title_shm_showcase_preview_83 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_shm_showcase_preview_84 = $mol_type_enforce<
		({ 
			'component': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_pick__trigger_content_shm_showcase_preview_85 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_showcase_preview_86 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_pop_over__Anchor_shm_showcase_preview_87 = $mol_type_enforce<
		ReturnType< $shm_showcase_preview['Hover_anchor'] >
		,
		ReturnType< $mol_pop_over['Anchor'] >
	>
	type $mol_pop_over__bubble_content_shm_showcase_preview_88 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pop_over['bubble_content'] >
	>
	type $mol_expander__title_shm_showcase_preview_89 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_shm_showcase_preview_90 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_labeler__title_shm_showcase_preview_91 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_showcase_preview_92 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_card__title_shm_showcase_preview_93 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_card['title'] >
	>
	type $mol_card__status_shm_showcase_preview_94 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_card['status'] >
	>
	type $mol_list__rows_shm_showcase_preview_95 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_bar__sub_shm_showcase_preview_96 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_bar['sub'] >
	>
	type $mol_view__sub_shm_showcase_preview_97 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_showcase_preview extends $mol_view {
		Chart_line( ): $mol_plot_line
		Calendar( ): $mol_calendar
		Stack_back( ): $mol_avatar
		Stack_front( ): $mol_speck
		pop_opened( next?: boolean ): boolean
		Pop_toggle( ): $mol_check_box
		Auto_theme( ): $mol_theme_auto
		file_title( ): string
		files( next?: readonly(File)[] ): readonly(File)[]
		period_from( next?: string ): string
		period_to( next?: string ): string
		Period( ): $shm_period
		Form_input( ): $mol_string
		Form_field( ): $mol_form_field
		textarea_value( next?: string ): string
		checks_value( next?: ({ 
			'a': boolean,
			'b': boolean,
		})  ): ({ 
			'a': boolean,
			'b': boolean,
		}) 
		multiple_value( next?: readonly(any)[] ): readonly(any)[]
		deck_current( next?: string ): string
		Tab_a( ): $mol_view
		Tab_b( ): $mol_view
		Scroll_content( ): $mol_list
		chart_option( ): any
		content( ): readonly(any)[]
		checked( next?: boolean ): boolean
		number_value( next?: number ): number
		switch_value( next?: string ): string
		select_value( next?: string ): string
		date_value( next?: string ): string
		time_value( next?: string ): string
		format_value( next?: string ): string
		page_value( next?: number ): number
		Hover_anchor( ): $mol_button_minor
		Action_a( ): $mol_button_minor
		Action_b( ): $mol_button_minor
		First( ): $mol_view
		Second( ): $mol_view
		Third( ): $mol_view
		entry_id( ): string
		Shm_paginator( ): $shm_paginator
		Chart( ): $mol_chart
		Calendar_pick( ): $mol_pick
		Stack( ): $mol_stack
		Pop( ): $mol_pop
		Lights( ): $mol_lights_toggle
		Theme( ): $mol_card
		Share( ): $mol_button_share
		File_drop( ): $shm_file_drop
		Period_pick( ): $mol_pick
		Form_pick( ): $mol_pick
		Form( ): $mol_form
		Grid( ): $mol_grid
		Search( ): $mol_search
		Textarea( ): $mol_textarea
		Checks( ): $mol_check_list
		Shm_checks( ): $shm_check_list
		Multiple( ): $mol_select_list
		Section( ): $mol_section
		Toolbar( ): $mol_toolbar
		Deck( ): $mol_deck
		Gallery( ): $mol_gallery
		Scroll( ): $mol_scroll
		Frame( ): $mol_frame
		Echarts( ): $shm_echarts
		sub( ): ReturnType< $shm_showcase_preview['content'] >
		Text( ): $mol_text
		Speck( ): $mol_speck
		Avatar( ): $mol_avatar
		Portion( ): $mol_portion
		Check( ): $mol_check_box
		String( ): $mol_string
		Button( ): $mol_button_minor
		Loader( ): $shm_dotsloader
		Code( ): $mol_text_code
		Number( ): $mol_number
		Switch( ): $mol_switch
		Select( ): $mol_select
		Date( ): $mol_date
		Time( ): $mol_pick_time
		Format( ): $mol_format
		Paginator( ): $mol_paginator
		Link( ): $mol_link
		Pick( ): $mol_pick
		Hover( ): $mol_pop_over
		Expander( ): $mol_expander
		Labeler( ): $mol_labeler
		Card( ): $mol_card
		List( ): $mol_list
		Bar( ): $mol_bar
		Items( ): $mol_view
	}
	
}

//# sourceMappingURL=preview.view.tree.d.ts.map